import type { ReactNode } from 'react';

export const symbol_in_home_mode: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M480-513ZM220-160q-24.75 0-42.37-17.63Q160-195.25 160-220v-340l-60 46q-9.61 8-21.8 6Q66-510 58-520.37q-8-9.63-6.06-21.82Q53.89-554.38 64-562l380-291q8.08-6 17.27-9 9.18-3 18.73-3t18.73 3q9.19 3 17.27 9l381 291q10 8 11.5 20t-6.5 22q-8 10-20 12t-22-6L480-805 220-605.67V-220h162q13.08 0 21.54 8.68 8.46 8.67 8.46 21.5 0 12.82-8.62 21.32-8.63 8.5-21.38 8.5H220Zm380 66q-5-2-10-7L477-214q-9-9-9-21t9-21q9-9 21-9t21 9l92 92 206-205q9-9 21-9t21 9q9 9 9 21t-9 21L632-101q-5 5-10.13 7-5.14 2-11 2Q605-92 600-94Z"
		/>
	</svg>
);
